import { Subject } from 'rxjs';

export class ExternalAppEventDispatch {
  eventName: string;
  externalAppEventNotification = new Subject<void>();
  constructor(eventName: string, isStartListen: boolean) {
    this.eventName = eventName;
    if (isStartListen) {
      this.startListen();
    }
  }
  startListen() {
    document.addEventListener(this.eventName, (e: any) => {
      console.log(e.detail);
      this.externalAppEventNotification.next(e.detail);
    });
  }
}
